/**
 * Jurisdictions for which a Double Tax Treaty (DTT) is indexed in the RAG backend.
 *
 * These strings are sent verbatim as `from_jurisdiction` / `to_jurisdiction` and
 * MUST match the backend's `COUNTRY_ISO` keys exactly (see rag-backend
 * `app/app.py`) — the backend looks each name up to derive the canonical treaty
 * pair, and an unknown name silently disables DTT scoping. Keep this list in sync
 * when the backend's country map changes.
 */
export const DTT_JURISDICTIONS = [
  "Albania", "Armenia", "Australia", "Austria", "Bahrain", "Bangladesh",
  "Barbados", "Belarus", "Belgium", "Bermuda", "Brazil", "Brunei", "Bulgaria",
  "Cambodia", "Canada", "Chile", "China", "Cyprus", "Czech Republic", "Denmark",
  "Ecuador", "Egypt", "Estonia", "Ethiopia", "Fiji", "Finland", "France",
  "Georgia", "Germany", "Ghana", "Greece", "Guernsey", "Hong Kong", "Hungary",
  "India", "Indonesia", "Ireland", "Isle of Man", "Israel", "Italy", "Japan",
  "Jersey", "Jordan", "Kazakhstan", "Korea", "Kuwait", "Laos", "Latvia",
  "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Malaysia", "Malta",
  "Mauritius", "Mexico", "Mongolia", "Morocco", "Myanmar", "Netherlands",
  "New Zealand", "Nigeria", "Norway", "Oman", "Pakistan", "Panama",
  "Papua New Guinea", "Philippines", "Poland", "Portugal", "Qatar", "Romania",
  "Russian Federation", "Rwanda", "San Marino", "Saudi Arabia", "Serbia",
  "Seychelles", "Singapore", "Slovak Republic", "Slovenia", "South Africa",
  "Spain", "Sri Lanka", "Sweden", "Switzerland", "Taiwan", "Thailand",
  "Tunisia", "Turkmenistan", "Türkiye", "UAE", "USA", "Ukraine",
  "United Kingdom", "Uruguay", "Uzbekistan", "Vietnam",
] as const

export type DttJurisdiction = (typeof DTT_JURISDICTIONS)[number]
